// TODO: Implement player services and uncomment related code

import {
  Box,
  Button,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  CircularProgress,
  TextField,
} from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TrashIcon from "@mui/icons-material/Delete";
// import { getPlayers, deletePlayer, createPlayer } from "../services/players";
import TablePagination from "@mui/material/TablePagination";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";

function Players() {
  const { user } = useKindeAuth();
  const [players, setPlayers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);

  // Extract user name from auth metadata
  const getUserName = (user) => {
    if (!user) return null;

    return (
      user.user_metadata?.full_name ||
      user.user_metadata?.name ||
      (user.user_metadata?.first_name && user.user_metadata?.last_name
        ? `${user.user_metadata.first_name} ${user.user_metadata.last_name}`
        : null) ||
      user.email ||
      "Unknown User"
    );
  };
  const [selectedPlayer, setSelectedPlayer] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [addPlayerDialog, setAddPlayerDialog] = useState(false);
  const [newPlayer, setNewPlayer] = useState({
    firstName: "",
    lastName: "",
    email: "",
    bsa_number: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [fetchingBsaData, setFetchingBsaData] = useState(false);
  const navigate = useNavigate();

  // Debounce search input
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
      setPage(0); // Reset to first page on new search
    }, 500);

    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    const fetchPlayers = async () => {
      try {
        setLoading(true);
        //const response = await getPlayers(page, rowsPerPage, debouncedSearch);
        //setPlayers(response.players || []);
        //setTotalCount(response.pagination?.total || 0);
      } catch (error) {
        console.error("Error fetching players:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPlayers();
  }, [page, rowsPerPage, debouncedSearch]);

  const handleDeleteClick = (player) => {
    setSelectedPlayer(player);
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    setSelectedPlayer(null);
  };

  const handleConfirmDelete = async () => {
    if (!selectedPlayer) return;
    try {
      const userName = getUserName(user);
      //await deletePlayer(selectedPlayer.id, user?.id, user?.email, userName);
      setPlayers((prev) => prev.filter((p) => p.id !== selectedPlayer.id));
      setTotalCount((prev) => prev - 1);

      // If this was the last item on the current page and we're not on page 0
      if (players.length === 1 && page > 0) {
        setPage(page - 1);
      }
    } catch (error) {
      console.error("Error deleting player:", error);
    }
    handleDialogClose();
  };

  const handlePlayerClick = (bsaNumber) => {
    navigate(`/players/${bsaNumber}`);
  };

  const handleAddPlayer = () => {
    setAddPlayerDialog(true);
  };

  const handleAddPlayerClose = () => {
    setAddPlayerDialog(false);
    setNewPlayer({
      firstName: "",
      lastName: "",
      email: "",
      bsa_number: "",
    });
  };

  const handleFetchBsaData = async () => {
    if (!newPlayer.bsa_number) {
      return;
    }

    try {
      setFetchingBsaData(true);
      // TODO: Implement BSA API call
      console.log("Fetching BSA data for:", newPlayer.bsa_number);

      // Simulate API call for now
      setTimeout(() => {
        // Mock data - replace with actual BSA API call
        setNewPlayer((prev) => ({
          ...prev,
          firstName: "John", // Replace with actual data
          lastName: "Doe", // Replace with actual data
          email: "john.doe@example.com", // Replace with actual data
        }));
        setFetchingBsaData(false);
      }, 1500);
    } catch (error) {
      console.error("Error fetching BSA data:", error);
      setFetchingBsaData(false);
    }
  };

  const handleAddPlayerSubmit = async () => {
    if (!newPlayer.firstName || !newPlayer.lastName || !newPlayer.bsa_number) {
      return;
    }

    try {
      setSubmitting(true);
      const userName = getUserName(user);
      //await createPlayer(newPlayer, user?.id, user?.email, userName);

      handleAddPlayerClose();

      // Refresh players list
      //const response = await getPlayers(page, rowsPerPage, debouncedSearch);
      //setPlayers(response.players || []);
      //setTotalCount(response.pagination?.total || 0);
    } catch (error) {
      console.error("Error creating player:", error);
      // TODO: Add error state/feedback to show user
    } finally {
      setSubmitting(false);
    }
  };

  // ...existing code...

  // Pagination handlers
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        Players
      </Typography>
      <Typography variant="body1" component="p">
        View and manage players in the system.
      </Typography>

      <Box sx={{ mt: 2, mb: 2, display: "flex", alignItems: "center", gap: 2 }}>
        <TextField
          label="Search players"
          variant="outlined"
          size="small"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{ mr: 2 }}
          placeholder="Search by name or BSA number"
        />
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleAddPlayer}
        >
          Add Player
        </Button>
        {debouncedSearch && (
          <Typography variant="caption" color="text.secondary">
            Searching for: "{debouncedSearch}"
          </Typography>
        )}
      </Box>
      {loading ? (
        <Box
          display="flex"
          flexDirection={"column"}
          justifyContent="center"
          alignItems="center"
          gap={2}
          sx={{ mt: 4, py: 4 }}
        >
          <CircularProgress />
          <Typography variant="caption" sx={{ ml: 2 }}>
            Loading players...
            {debouncedSearch && ` (searching for "${debouncedSearch}")`}
          </Typography>
        </Box>
      ) : (
        <Paper elevation={3} sx={{ mt: 2 }}>
          <Table sx={{ mt: 2 }}>
            <TableHead>
              <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                <TableCell>Name</TableCell>
                <TableCell>BSA Number</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Performance</TableCell>
                {/* <TableCell>Actions</TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {players.map((player) => {
                return (
                  <TableRow
                    key={player.id}
                    hover
                    onClick={() => handlePlayerClick(player.bsa_number)}
                    sx={{ cursor: "pointer" }}
                  >
                    <TableCell>
                      {player.lastName}, {player.firstName}
                    </TableCell>
                    <TableCell>{player.bsa_number}</TableCell>
                    <TableCell>{player.email}</TableCell>
                    <TableCell>{player.entries?.[0]?.count || 0}</TableCell>
                    {/* <TableCell>
                      <IconButton
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteClick(player);
                        }}
                      >
                        <TrashIcon color="error" />
                      </IconButton>
                    </TableCell> */}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <TablePagination
            component="div"
            count={totalCount}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[5, 10, 25, 50]}
          />
        </Paper>
      )}

      {/* Add Player Dialog */}
      <Dialog
        open={addPlayerDialog}
        onClose={handleAddPlayerClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Add New Player</DialogTitle>
        <DialogContent sx={{ mt: 1 }}>
          <TextField
            label="BSA Number"
            fullWidth
            required
            margin="normal"
            value={newPlayer.bsa_number}
            onChange={(e) =>
              setNewPlayer({ ...newPlayer, bsa_number: e.target.value })
            }
            helperText="Unique BSA membership number"
          />
          <Box sx={{ mb: 2 }}>
            <Button
              variant="outlined"
              size="small"
              onClick={handleFetchBsaData}
              disabled={!newPlayer.bsa_number || fetchingBsaData}
              sx={{ mt: 1 }}
            >
              {fetchingBsaData ? "Fetching..." : "Get Details"}
            </Button>
          </Box>
          <TextField
            label="First Name"
            fullWidth
            required
            margin="normal"
            value={newPlayer.firstName}
            onChange={(e) =>
              setNewPlayer({ ...newPlayer, firstName: e.target.value })
            }
          />
          <TextField
            label="Last Name"
            fullWidth
            required
            margin="normal"
            value={newPlayer.lastName}
            onChange={(e) =>
              setNewPlayer({ ...newPlayer, lastName: e.target.value })
            }
          />
          <TextField
            label="Email"
            fullWidth
            margin="normal"
            type="email"
            value={newPlayer.email}
            onChange={(e) =>
              setNewPlayer({ ...newPlayer, email: e.target.value })
            }
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAddPlayerClose}>Cancel</Button>
          <Button
            onClick={handleAddPlayerSubmit}
            variant="contained"
            disabled={
              submitting ||
              !newPlayer.firstName ||
              !newPlayer.lastName ||
              !newPlayer.bsa_number
            }
          >
            {submitting ? "Adding..." : "Add Player"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <Dialog open={openDialog} onClose={handleDialogClose}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this player? This action cannot be
            undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary">
            Cancel
          </Button>
          <Button
            onClick={handleConfirmDelete}
            color="error"
            variant="contained"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default Players;
